
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import { MixinsHomeClick } from '@xt/client/mixins/home'
import type { CalligraphyLevel2JsonResp } from '@xt/client/utils/activities/types.d.ts'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class TopIntro extends Mixins(MixinsHomeClick) {
  @Prop({ required: true }) readonly dataSource!: CalligraphyLevel2JsonResp

  handleMore() {
    const { more } = this.dataSource

    if (more) {
      this.onClickEvent(more)
      return
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
